import { ethers } from 'ethers';
import { CHAIN_ID, normalizeChainId } from './connectionConfig';
import { getActiveProvider } from './walletProvider';

/**
 * Подписант из кошелька оператора, с проверкой сети.
 *
 * Вынесен отдельно от `getContract`: подпись нужна не только транзакциям.
 * Изменение расписания выплат подписывается тем же кошельком, но уходит не в
 * блокчейн, а на бэкенд, где по подписи проверяется `hasRole(ADMIN_ROLE)`.
 */
export async function getSigner() {
  const wallet = getActiveProvider();

  if (!wallet) {
    throw new Error('Кошелёк не подключён. Подключите кошелёк и повторите.');
  }

  const provider = new ethers.BrowserProvider(wallet);
  const network = await provider.getNetwork();

  // Сеть могли переключить уже после подключения панели. Транзакция в чужой
  // сети ушла бы по этому адресу в никуда — проверяем непосредственно перед
  // подписью, а не только в момент подключения.
  if (normalizeChainId(network.chainId) !== CHAIN_ID) {
    throw new Error(
      'Кошелёк не в сети BSC. Переключите сеть и повторите операцию.',
    );
  }

  return provider.getSigner();
}

export default async function getContract(address, abi) {
  return new ethers.Contract(address, abi, await getSigner());
}
